import { ReactNode } from 'react';

import Button from '../../../components/Button/Button';
import InlineIcon from '../../../components/InlineIcon/InlineIcon';
import Row from '../../../components/Row/Row';
import Text from '../../../components/Text/Text';
import useIsMobile from '../../../hooks/ui/useIsMobile';

type OverlayHeaderButtonProps = {
    icon: string;
    children: ReactNode;
    onClick?: () => void;
};

const OverlayHeaderButton = ({
    children,
    onClick,
    icon,
}: OverlayHeaderButtonProps) => {
    const isMobile = useIsMobile();

    return (
        <Button
            onClick={onClick}
            variant="text-translucent-hover"
            size={isMobile ? 'xsmall' : 'medium-narrow'}
        >
            <Row space="small" vertical="middle">
                <InlineIcon src={icon} />
                <Text lineHeight="small" size={isMobile ? 'small' : 'default'}>
                    {children}
                </Text>
            </Row>
        </Button>
    );
};

export default OverlayHeaderButton;
